/* slick default setting */
let defaulsettings = {
    loop: true,
    speed: 700,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        nextEl: '.swiper-prev',
        prevEl: '.swiper-next'
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    }
};

/* start slider default */
let allSwipper = [];
let swiperGallery;
let swiperGallerySub;
let featuredRoomsText;
let featuredRoomsImg;
let sliderWithPreviewTemplate2TXT;
let sliderWithPreviewTemplate2IMG;

function initAllSwipers() {
    document.querySelectorAll('.swiper-slider').forEach((element, i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`, "");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });
}
document.addEventListener('DOMContentLoaded', () => {
    console.log('Load DOM content to build sliders');
    initAllSwipers();

    swiperGallery = new Swiper('.swiper-gallery-main', {
        loop: true,
        effect: 'fade',
        allowTouchMove: true,
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 7000
        },
        navigation: {
            prevEl: ".gallery_arrow.prev-arrow",
            nextEl: ".gallery_arrow.next-arrow"
        },
        pagination: {
            el: ".gallery_pagination",
            clickable: true
        },
        breakpoints: {
            640: {
                allowTouchMove: false
            }
        }
    });

    swiperGallerySub = new Swiper('.swiper-gallery-sub', {
        loop: true,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    swiperGallery.controller.control = swiperGallerySub;


    featuredRoomsImg = new Swiper('.featuredRoom_imageContent_slider', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 48,
        centeredSlides: false,
        allowTouchMove: true,
        autoplay: {
            delay: 7000,
        },
        navigation: {
            prevEl: ".featuredRoom_arrow.prev-arrow",
            nextEl: ".featuredRoom_arrow.next-arrow",
        },
        pagination: {
            el: ".featuredRoom_pagination",
            clickable: true
        },
        breakpoints: {
            640: {
                allowTouchMove: false,
                slidesPerView: 1.2,
            }
        }
    });

    featuredRoomsText = new Swiper('.featuredRoom_textContent_slider', {
        loop: true,
        effect: "fade",
        allowTouchMove: true,
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 7000,
        },
        navigation: {
            prevEl: ".featuredRoom_arrow.prev-arrow",
            nextEl: ".featuredRoom_arrow.next-arrow",
        },
        pagination: {
            el: ".featuredRoom_pagination",
            clickable: true
        },
        breakpoints: {
            640: {
                allowTouchMove: false
            }
        }
    });

    if( window.innerWidth < 641 ){
        featuredRoomsText.controller.control = featuredRoomsImg;
        featuredRoomsImg.controller.control = featuredRoomsText;
    }



    sliderWithPreviewTemplate2TXT = new Swiper('.sliderWithPreview_textCarousel', {
        loop: true,
        slidesPerView: 1,
        allowTouchMove: true,
        autoplay: {
            delay: 7000,
        },
        navigation: {
            prevEl: ".sliderWithPreview_arrow.prev-arrow",
            nextEl: ".sliderWithPreview_arrow.next-arrow",
        },
        pagination: {
            el: ".sliderWithPreview_pagination",
            clickable: true
        },
        breakpoints: {
            640: {
                allowTouchMove: false
            }
        }
    });

    sliderWithPreviewTemplate2IMG = new Swiper('.sliderWithPreview_imagesCarousel', {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        slidesOffsetBefore: 0,
        spaceBetween: 48,
        allowTouchMove: true,
        autoplay: {
            delay: 7000,
        },
        navigation: {
            prevEl: ".sliderWithPreview_arrow.prev-arrow",
            nextEl: ".sliderWithPreview_arrow.next-arrow",
        },
        pagination: {
            el: ".sliderWithPreview_pagination",
            clickable: true
        },
        breakpoints: {
            640: {
                slidesOffsetBefore: 80,
                allowTouchMove: false
            }
        }
    });

    if( window.innerWidth < 641 ){
        sliderWithPreviewTemplate2TXT.controller.control = sliderWithPreviewTemplate2IMG;
        sliderWithPreviewTemplate2IMG.controller.control = sliderWithPreviewTemplate2TXT;
    }
});